import { useQuery } from '@tanstack/react-query';
import { shareService } from '../services/shareService';
import type { ShareResourceType } from '../types';

export function useEffectiveAccess(
  resourceType: ShareResourceType,
  resourceId: string | undefined,
  enabled = true,
) {
  return useQuery({
    queryKey: ['shares', 'check', resourceType, resourceId],
    queryFn: () => shareService.checkAccess(resourceType, resourceId as string),
    enabled: enabled && !!resourceId,
  });
}
